import {Button} from 'antd'
import {useFilterByLicense} from '@/biz/license.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'
import {canPreviewUv, previewUv} from './previewUv.mjs'

export default function PropertiesPaneButtonPreview(props) {
    const filterByLicense = useFilterByLicense()
    const map = useMapContext()
    const [node] = map.useSelectedNodes()

    if (! canPreviewUv(map, node)) {
        return null
    }

    const handleClick = e => {
        const target = e.altKey ? '_self' : '_blank'
        previewUv(map, node, target)
    }

    return filterByLicense('M00030002',
        <Button
            onClick={handleClick}
            {...props}
        >
            界面看板
        </Button>
    )
}
